import './styles.css';
import { MailOutlined } from '@ant-design/icons';
import { Button, Form, Image, Input, Typography, message } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import icon from '../../assets/images/icon.svg';
import { appConfig } from '../../config/appConfig';
import { auth } from '../../services/firebase';

export const LoginPage = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (!token) {
      return;
    }

    auth
      .signInWithCustomToken(token)
      .then((result) => {
        if (result.user) {
          messageApi.open({
            type: 'success',
            content: 'Successfully signed in',
          });
        } else {
          messageApi.open({
            type: 'error',
            content: 'Error signing in',
          });
        }
      })
      .catch((error) => {
        messageApi.open({
          type: 'error',
          content: error.message,
        });
      });
  }, []);

  const onFinish = async (values: { email: string }) => {
    try {
      setLoading(true);
      console.log(values.email);
      await auth.sendSignInLinkToEmail(values.email, {
        url: `http://localhost:3000/login?email=${values.email}`,
      });
    } catch (error: any) {
      console.log(JSON.stringify(error));
      messageApi.open({
        type: 'error',
        content: error.message,
      });
    }
    setLoading(false);
  };

  return (
    <div className="login">
      <div className="login-form">
        <div className="login-form-inner">
          {contextHolder}

          <Image width={40} src={icon} preview={false} />

          <Typography.Title style={{ marginBottom: 0, marginTop: 12, fontWeight: 'bold' }}>
            {appConfig.companyName}
          </Typography.Title>
          <Typography.Text>Welcome back, please enter your email to continue</Typography.Text>

          <Form
            style={{ marginTop: 32 }}
            requiredMark={false}
            initialValues={{ remember: true }}
            layout="vertical"
            size="large"
            onFinish={onFinish}>
            <Form.Item
              style={{ marginBottom: 12 }}
              name="email"
              label="Email"
              rules={[{ required: true, message: '' }]}>
              <Input disabled={loading} prefix={<MailOutlined />} placeholder="mail@example.com" />
            </Form.Item>

            <Form.Item>
              <Button block loading={loading} type="primary" htmlType="submit">
                Send magic link
              </Button>
            </Form.Item>
            <Form.Item style={{ textAlign: 'center' }}>
              Don't have an account?{' '}
              <Link to="/signup">
                <strong>Sign up!</strong>
              </Link>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className="login-extra-content">
        <div className="login-extra-content-container">
          <Typography.Title level={4}>
            Ready to innovate and collaborate? Let's make tech magic happen.
          </Typography.Title>
          <br />
          <Typography.Text italic>Dive back into your projects and lead the way.</Typography.Text>
        </div>
      </div>
    </div>
  );
};
